import React, { useEffect, useState, useRef } from "react";
import { Subject, Subscription } from "rxjs";

export const agreementModalSubject = new Subject();

const AgreementModal = (props: any) => {
    const [showModal, setShowModal] = useState<any>(false);
    const [hasScrolledToBottom, setHasScrolledToBottom] = useState<boolean>(false);
    const bodyRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const subscription: Subscription = agreementModalSubject.subscribe((obj: any) => {
            if (obj) {
                setShowModal(obj);
                setHasScrolledToBottom(false);
            } else {
                closeModal();
            }
        });
        return () => {
            subscription.unsubscribe();
        };
    }, []);

    useEffect(() => {
        const checkIfScrollable = () => {
            if (bodyRef.current) {
                const { scrollHeight, clientHeight } = bodyRef.current;
                if (scrollHeight <= clientHeight) {
                    setHasScrolledToBottom(true);
                }
            }
        };

        const timer = setTimeout(checkIfScrollable, 100);
        
        return () => clearTimeout(timer);
    }, [showModal]);

    const handleScroll = () => {
        if (bodyRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = bodyRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 5) {
                setHasScrolledToBottom(true);
            }
        }
    };

    const closeModal = () => {
        if (showModal && showModal.onClose) {
            showModal.onClose();
        }
        setShowModal(false);
    };

    if (showModal) {
        return (
            <>
                {props.children}
                <div
                    className={`modal show agreement-modal ${showModal.class || ""}`}
                    style={{
                        width: showModal.width ? showModal.width : "auto",
                        maxWidth: showModal.width ? "calc(100vw - 40px)" : "",
                    }}
                >
                    {showModal.title && (
                        <div className="header">
                            {showModal.title}
                        </div>
                    )}

                    <div
                        ref={bodyRef}
                        onScroll={handleScroll}
                        className="body"
                        style={{ 
                            maxHeight: "calc(100vh - 200px)", 
                            height: showModal.height ? showModal.height : "auto",
                            overflowY: "auto"
                        }}
                        dangerouslySetInnerHTML={{
                            __html: showModal.content,
                        }}
                    ></div>

                    <div className="footer p-2 text-end">
                        {showModal.confirm ? (
                            <>
                                {showModal.confirm.sure && (
                                    <button
                                        id="id_btnAgreementModalAccept"
                                        className={"btn " + (showModal.confirm.sure.class || "btn-success")}
                                        disabled={!hasScrolledToBottom}
                                        onClick={() => {
                                            if (showModal.confirm.sure.action) {
                                                showModal.confirm.sure.action();
                                            }
                                            if (showModal.confirm.sure.autoClose !== false) {
                                                closeModal();
                                            }
                                        }}
                                    >
                                        {showModal.confirm.sure.label || "Kabul Ediyorum"}
                                    </button>
                                )}
                                {showModal.confirm.cancel && (
                                    <button
                                        id="id_btnAgreementModalClose"
                                        className={"btn " + (showModal.confirm.cancel.class || "btn-secondary")}
                                        onClick={() => {
                                            if (showModal.confirm.cancel.action) {
                                                showModal.confirm.cancel.action();
                                            }
                                            closeModal();
                                        }}
                                    >
                                        {showModal.confirm.cancel.label || "Kapat"}
                                    </button>
                                )}
                            </>
                        ) : (
                            <button
                                className="btn btn-secondary"
                                onClick={closeModal}
                            >
                                Kapat
                            </button>
                        )}
                    </div>
                </div>
                <div
                    onClick={closeModal}
                    className="modal-backdrop show"
                ></div>
            </>
        );
    }
    return <>{props.children}</>;
};

export default AgreementModal;
